import {RouterModule} from '@angular/router';
import {NgModule} from '@angular/core';
import {AuthGuard} from './common/auth/guards/auth.guard';
import {SessionGuard} from './common/auth/guards/session.guard';
import {DevComponent} from './application/dev/dev.component';

@NgModule({
    imports: [
        RouterModule.forRoot([
            {
                path: 'dev', component: DevComponent, pathMatch: 'full', canActivate: [AuthGuard]
            },
            {
                // the portal is public - only the routes that work with the user's own
                // data are guarded, see ApplicationRouting
                path: '',
                loadChildren: () => import('./application/application.module').then(m => m.ApplicationModule),
                canActivate: [SessionGuard]
            },
            {
                path: 'public',
                loadChildren: () => import('./application/public/public-section.module').then(m => m.PublicSectionModule),
            },
        ], {scrollPositionRestoration: 'enabled', anchorScrolling: 'enabled'}),
    ],
    providers: [
        AuthGuard,
        SessionGuard,
    ],
    exports: [RouterModule],
})
export class AppRoutingModule {
}
